import React from 'react'
import type { Icon } from 'shared/utils'

const Chicken = (props: Icon) => {
    const { color = 'black', size = 24, className = 'chicken' } = props
    return (
        <svg fill={color} width={size} height={size} className={className}>
            <path
                d="M19.324 6.133c.052 0 .193.06.369.06.294 0 .688-.168.934-1.066.028-.102.165-.132.337-.132.236 0 .54.055.732.055.094 0 .16-.013.179-.053.166-.358-.579-.984-.646-1.182C20.996 3.131 20.054 2 18.704 2c-.1 0-.204.006-.31.02-.632.08-.347.694-.784.853-2.112.763-1.957 3.285-3.262 4.036-.84.483-3.179.89-4.707.89-.426 0-.789-.031-1.04-.102-.999-.28-3.013-3.912-4.586-3.912h-.023c-1.364.032-2.486 1.957-1.769 5.706.256 1.335 2.678 2.1 2.94 2.738 1.395 3.407 3.593 4.987 5.197 5.566.454.183.793.628.828.948l.098.765a.488.488 0 0 1-.107.367.234.234 0 0 1-.187.086h-.364a.655.655 0 0 0 0 1.308h.364c.386 0 .744-.137 1.028-.389.325.258.742.394 1.24.394h1.444a.655.655 0 0 0 0-1.308h-1.443c-.36 0-.575-.102-.679-.632l-.068-.572c-.068-.672.522-1.023.712-1.117 2.107-.869 5.43-2.98 6.14-5.408.708-2.425-.235-4.955-.064-6.091.002-.01.009-.013.022-.013"
                fillRule="evenodd"
            />
        </svg>
    )
}

export { Chicken }
